import EXIF from 'exif-js';
import * as Sentry from '@sentry/react';

type GetCoordinatesResponse = {
  latitude?: string;
  longitude?: string;
};

export const getCoordinates = (file): Promise<GetCoordinatesResponse> => {
  return new Promise((resolve, _reject) => {
    EXIF.getData(file, function () {
      const lat = EXIF.getTag(file, 'GPSLatitude');
      const lon = EXIF.getTag(file, 'GPSLongitude');
      const latRef = EXIF.getTag(file, 'GPSLatitudeRef');
      const lonRef = EXIF.getTag(file, 'GPSLongitudeRef');

      if (lat && lon && latRef && lonRef) {
        const latitude = (lat[0] + lat[1] / 60 + lat[2] / 3600) * (latRef === 'N' ? 1 : -1);
        const longitude = (lon[0] + lon[1] / 60 + lon[2] / 3600) * (lonRef === 'E' ? 1 : -1);

        return resolve({ latitude: latitude.toString(), longitude: longitude.toString() });
      } else {
        navigator.geolocation.getCurrentPosition(
          (position) => {
            const latitude = position.coords.latitude;
            const longitude = position.coords.longitude;

            return resolve({ latitude: latitude.toString(), longitude: longitude.toString() });
          },
          (err: unknown) => {
            Sentry.captureException(err);

            return resolve({ latitude: undefined, longitude: undefined });
          },
        );
      }
    });
  });
};
